import { adminGroupConstants } from '../_constants';

export function group(state = {}, action) {
  switch(action.type) {
    default:
      return state;
  }
}
